import _ from 'lodash'
import { createApp } from 'vue'
import axios from 'axios'
import mixins from './vue/mixins'


window._ = _
window.axios = axios


window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
}


import ShopSearchBar from './vue/components/shop-search-bar/ShopSearchBar'
import ProductOffer from './vue/components/product-offer/ProductOffer'
import ProductEvaluations from './vue/components/product-evaluations/ProductEvaluations'
import CartOverview from './vue/components/cart/CartOverview'
import CartDelivery from './vue/components/cart/CartDelivery'
import CartPayment from './vue/components/cart/CartPayment'
import LastSeen from './vue/components/last-seen/LastSeen'
import ProductSkeleton from './vue/components/product-offer/ProductSkeleton'


const app = createApp({
    components: {
        ShopSearchBar,
        ProductOffer,
        ProductEvaluations,
        CartOverview,
        CartDelivery,
        CartPayment,
        LastSeen,
        ProductSkeleton
    }
})


app.mixin( mixins ).mount('#app')


try {
    window.$ = window.jQuery = require('jquery')
} catch (e) {}


require('./jquery/calc-css-properties')
require('./jquery/slick-slider')
require('./jquery/product-filters-block-title')
require('./jquery/add-to-cart')
require('./jquery/auth-popups')
require('./jquery/add-product-to-last-seen')
require('./jquery/nav-btn')
require('./jquery/order-summary')
require('./jquery/analytics-scripts')
require('./jquery/preview-popup')
